import {
  APPLE_RANDOM_EMAIL_SUFFIXES,
  FACEBOOK_RANDOM_EMAIL_SUFFIXES,
} from '@src/constants/email';

const checkUserHasProvidedEmail = (user) => {
  if (!user?.email) return false;

  const isFakeEmail = [
    FACEBOOK_RANDOM_EMAIL_SUFFIXES,
    APPLE_RANDOM_EMAIL_SUFFIXES,
  ].some((suffix) => user?.email?.includes(suffix));

  return !isFakeEmail;
};

export { checkUserHasProvidedEmail };
